import { render, staticRenderFns } from "./FrundImport.vue?vue&type=template&id=09fba1b6&scoped=true&"
import script from "./FrundImport.vue?vue&type=script&lang=js&"
export * from "./FrundImport.vue?vue&type=script&lang=js&"
import style0 from "./FrundImport.vue?vue&type=style&index=0&id=09fba1b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fba1b6",
  null
  
)

export default component.exports